import { useEffect } from "react";
import { useSearchParams, useLocation } from "react-router-dom";
import { DiagnosticProvider, useDiagnostic } from "@/components/landing/DiagnosticContext";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { TrustStrip } from "@/components/landing/TrustStrip";
import { Marquee } from "@/components/landing/Marquee";
import { StepPath } from "@/components/landing/StepPath";
import { Tracks } from "@/components/landing/Tracks";
import { Projects } from "@/components/landing/Projects";
import { WhoFor } from "@/components/landing/WhoFor";
import { ReadinessCard } from "@/components/landing/ReadinessCard";
import { Faq } from "@/components/landing/Faq";
import { CtaBand, Footer } from "@/components/landing/CtaFooter";
import { DiagnosticModal } from "@/components/diagnostic/DiagnosticModal";
import { WhatYouGet } from "@/components/landing/WhatYouGet";
import { Pathway } from "@/components/landing/Pathway";
import { ToolkitPopup } from "@/components/landing/ToolkitPopup";
import { UpcomingBatches } from "@/components/landing/UpcomingBatches";

function UrlActions() {
  const [params] = useSearchParams();
  const { hash } = useLocation();
  const { open } = useDiagnostic();
  useEffect(() => {
    if (params.get("diagnostic") === "1") { sessionStorage.setItem("aor_popup_seen", "1"); open(); }
  }, [params, open]);
  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 400);
    return () => clearTimeout(t);
  }, [hash]);
  return null;
}

export default function Landing() {
  return (
    <DiagnosticProvider>
      <div data-testid="landing-page" className="min-h-screen overflow-x-clip bg-[#F7FAFC]">
        <Nav />
        <main>
          <Hero />
          <TrustStrip />
          <Marquee />
          <div className="mx-auto grid max-w-[1360px] gap-8 px-5 py-12 lg:grid-cols-[minmax(0,1fr)_330px] lg:px-10">
            <div className="min-w-0 space-y-8">
              <StepPath />
              <Tracks />
              <WhatYouGet />
              <Projects />
              <WhoFor />
            </div>
            <aside className="min-w-0"><ReadinessCard /></aside>
          </div>
          <UpcomingBatches />
          <Pathway />
          <Faq />
          <CtaBand />
        </main>
        <Footer />
        <DiagnosticModal />
        <ToolkitPopup />
        <UrlActions />
      </div>
    </DiagnosticProvider>
  );
}
